import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'

import Input from 'components/modules/inputs/Input/Input'

const EmailFormScene = () => {
  const { register, watch, setValue } = useFormContext()
  const emailWatch = watch('email')

  const handleClear = () => {
    setValue('email', '')
  }

  return (
    <>
      <Title>{`이메일 주소를 입력해주세요:)`}</Title>
      <Description>{`상품 수령을 위해 자주 쓰이는 이메일을 입력해 주세요`}</Description>
      <Input {...register('email')} isClearBtn={emailWatch.length > 0} onClear={handleClear} />
    </>
  )
}

const Title = styled.h1`
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (29 / 375));
  white-space: pre-wrap;
  margin-bottom: calc(100vw * (8 / 375));
`

const Description = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (22 / 375));
  color: #7f7f7f;
  margin-bottom: calc(100vw * (35 / 375));
`

export default EmailFormScene
